"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadUrlRequest = void 0;
/**
 * Upload URL request interface
 * @doc UploadUrlRequest
 */
var media_platform_1 = require("../../../types/media-platform/media-platform");
/**
 * Upload URL request class
 * @doc UploadUrlRequest
 */
var UploadUrlRequest = /** @class */ (function () {
    function UploadUrlRequest(data) {
        this.acl = media_platform_1.ACL.PUBLIC;
        this.mimeType = null;
        this.path = null;
        this.size = null;
        this.acl = data.acl;
        this.mimeType = data.mimeType;
        this.path = data.path;
        this.size = data.size;
    }
    return UploadUrlRequest;
}());
exports.UploadUrlRequest = UploadUrlRequest;
//# sourceMappingURL=upload-url-request.js.map